<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>

        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="jumpToCreate"
          >创建</el-button
        >
      </div>
    </customize-page>
    <el-dialog title="编辑出库单" width="900px" :visible.sync="dialogVisible">
      <el-form
        ref="form"
        :model="toBStockoutOrderForm"
        label-width="110px"
        size="mini"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="收件人">
          <el-input v-model="toBStockoutOrderForm.consignee"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="toBStockoutOrderForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="省">
          <el-input v-model="toBStockoutOrderForm.province"></el-input>
        </el-form-item>
        <el-form-item label="市">
          <el-input v-model="toBStockoutOrderForm.city"></el-input>
        </el-form-item>
        <el-form-item label="区">
          <el-input v-model="toBStockoutOrderForm.district"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="toBStockoutOrderForm.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateStockoutOrder"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="创建出口核注单"
      width="1000px"
      :visible.sync="showMakeHeZhuDirectFormFlag"
    >
      <el-form
        ref="form"
        :model="heZhuForm"
        label-width="110px"
        :rules="rules"
        size="mini"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="清单类型" prop="billType">
          <!-- 0：普通清单，1：集报清单，3：先入区后报关，4：简单加工，5：保税展示交易，6：区内流转，7：区港联动，8:保税电商，9：一纳成品内销默认为0：普通清单 -->
          <el-select v-model="heZhuForm.billType">
            <el-option value="0" label="普通清单"></el-option>
            <el-option value="1" label="集报清单"></el-option>
            <el-option value="3" label="先入区后报关"></el-option>
            <el-option value="4" label="简单加工"></el-option>
            <el-option value="5" label="保税展示交易"></el-option>
            <el-option value="6" label="区内流转"></el-option>
            <el-option value="7" label="区港联动"></el-option>
            <el-option value="8" label="保税电商"></el-option>
            <el-option value="9" label="一纳成品内销"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营企业" prop="bizOpCompanyCode">
          <el-select filterable v-model="heZhuForm.bizOpCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货企业" prop="rcvCompanyCode">
          <el-select filterable v-model="heZhuForm.rcvCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报企业" prop="dclCompanyCode">
          <el-select filterable v-model="heZhuForm.dclCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监管方式" prop="tradeMode">
          <el-select filterable v-model="heZhuForm.tradeMode">
            <el-option
              v-for="item in getTradeMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式" prop="transMode">
          <el-select filterable v-model="heZhuForm.transMode">
            <el-option
              v-for="item in getTransMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账册号" prop="emsNo">
          <el-input v-model="heZhuForm.emsNo"></el-input>
        </el-form-item>
        <el-form-item label="起运国" prop="startShipCountry">
          <el-input v-model.number="heZhuForm.startShipCountry"></el-input>
        </el-form-item>
        <el-form-item label="关联账册备案号">
          <el-input v-model="heZhuForm.rltEmsNo"></el-input>
        </el-form-item>
        <el-form-item label="关联清单编号">
          <el-input v-model="heZhuForm.rltInvtNo"></el-input>
        </el-form-item>
        <el-table
          :data="stockoutGoods"
          :border="true"
          style="margin-bottom: 10px"
        >
          <el-table-column prop="skuName" label="商品备案名称">
          </el-table-column>
          <el-table-column prop="itemNo" label="商品料号" width="150">
          </el-table-column>
          <el-table-column
            prop="planStockoutQuantity"
            label="出库数量"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="planStockoutQuantity"
            label="申报数量"
            width="100"
          ></el-table-column>
          <el-table-column prop="unitPrice" label="申报单价" width="100">
            <template slot="header">
              单价
              <a style="font-size: 10px; color: #409eff" @click="copyUnitPrice"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="申报币种" width="100">
            <template slot="header">
              币种
              <a style="font-size: 10px; color: #409eff" @click="copyCurrency"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input-number
                style="width: 100%"
                v-model.number="scope.row.currency"
                size="mini"
                :controls="false"
                :precision="0"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button type="primary" @click="createHeZhuOrder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import b2bApi from "@/api/b2b";
import heZhuApi from "@/api/heZhuApi";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getTradeMode: "getTradeMode",
      getTransMode: "getTransMode",
      getCustomerList: "getCustomerList",
    }),
  },
  data() {
    return {
      loading: false,
      dataList: [],
      itemMap: {},
      toBStockoutOrderForm: {},
      showMakeHeZhuDirectFormFlag: false,
      heZhuForm: {},
      stockoutGoods: [],
      rules: {
        emsNo: [
          { required: true, message: "账册号不能为空", trigger: "blur" },
          { len: 12, message: "账册号为12个字符", trigger: "blur" },
        ],
        billType: [
          { required: true, message: "清单类型不能为空", trigger: "change" },
        ],
        bizOpCompanyCode: [
          { required: true, message: "请选择经营企业", trigger: "change" },
        ],
        rcvCompanyCode: [
          { required: true, message: "请选择收货企业", trigger: "change" },
        ],
        dclCompanyCode: [
          { required: true, message: "请选择申报企业", trigger: "change" },
        ],
        tradeMode: [
          { required: true, message: "请选择监管方式", trigger: "change" },
        ],
        transMode: [
          { required: true, message: "请选择运输方式", trigger: "change" },
        ],
        startShipCountry: [
          { required: true, message: "请输入起运国代码", trigger: "blur" },
          { type: "number", message: "起运国必须为数字", trigger: "blur" },
        ],
      },
      columns: [
        {
          type: "expand",
          render: (h, params) => {
            if (!this.itemMap[params.row.id]) {
              b2bApi
                .load({
                  toBStockoutOrderId: params.row.id,
                })
                .then((res) => {
                  this.itemMap[params.row.id] = res.items;
                  this.itemMap = { ...this.itemMap };
                });
            }
            return (
              <el-table
                border
                style="width: 100%"
                data={this.itemMap[params.row.id]}
              >
                <el-table-column
                  align="center"
                  prop="skuName"
                  label="商品名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="barcode"
                  label="商品条码"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="planStockoutQuantity"
                  label="计划出库数量"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="actualStockoutQuantity"
                  label="实际出库数量"
                  width="150"
                ></el-table-column>
              </el-table>
            );
          },
        },
        {
          title: "外部订单号",
          key: "outBizId",
          align: "center",
          width: 200,
        },
        {
          title: "货主id",
          key: "customerId",
          align: "center",
          width: 200,
        },
        {
          title: "出库单类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            const typeMap = {
              STOCKOUT: "B端出库",
            };

            return <span>{typeMap[params.row.type]}</span>;
          },
        },
        {
          title: "仓库编码",
          key: "warehouseId",
          align: "center",
        },
        {
          title: "申报状态",
          key: "declareState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              WAIT_DECLARE: ["info", "待申报"],
              DECLARE_FAIL: ["error", "申报失败"],
              DECLARE_SUCCESS: ["success", "申报成功"],
            };
            return (
              <div>
                <el-tag type={tagType[row.declareState][0]}>
                  {tagType[row.declareState][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "出库状态",
          key: "state",
          align: "center",
          render: (h, params) => {
            const tagType = {
              WAIT_STOCKOUT: ["info", "待出库"],
              STOCKOUTING: ["warning", "出库中"],
              CANCELED: ["info", "已取消"],
              SHIPPED: ["success", "已出库"],
            };
            return (
              <div>
                <el-tag type={tagType[params.row.state][0]}>
                  {tagType[params.row.state][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "推送wms状态",
          width: 200,
          key: "wmsState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待推送"],
              WMS_CREATE_SUCCESS: ["success", "推送仓库成功"],
              START_TALLY: ["success", "开始理货"],
              TALLY_FINISHED: ["success", "理货完成"],
              WMS_CREATE_EXCEPTION: ["error", "推送仓库异常"],
              STOCKOUT_FINISHED: ["success", "出库完成"],
              CANCELED: ["info", "已取消"],
            };
            return (
              <div>
                <el-tag type={tagType[row.wmsState][0]}>
                  {tagType[row.wmsState][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "发货时间",
          key: "gmtShip",
          align: "center",
          width: 200,
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center",
          width: 200,
        },
        {
          width: 300,
          title: "操作",
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.jumpToHeZhuList.bind(this, row)}
                >
                  查看核注单
                </a>
                {row.declareState !== "DECLARE_SUCCESS" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.showMakeHeZhuDirectForm.bind(this, row)}
                  >
                    生成核注清单
                  </a>
                ) : (
                  ""
                )}
                {row.state === "WAIT_STOCKOUT" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.showDialog.bind(this, row)}
                  >
                    编辑
                  </a>
                ) : (
                  ""
                )}
                {row.state === "WAIT_STOCKOUT" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.cancel.bind(this, row)}
                  >
                    取消
                  </a>
                ) : (
                  ""
                )}
                {row.source !== "DOUYIN" &&
                row.declareState === "DECLARE_SUCCESS" &&
                (row.state === "WAIT_STOCKOUT" ||
                  row.state === "STOCKOUTING") ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.ship.bind(this, row)}
                  >
                    确认出库
                  </a>
                ) : (
                  ""
                )}
                {["INIT", "WMS_CREATE_EXCEPTION"].includes(row.wmsState) ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.sendWms.bind(this, row)}
                  >
                    下发仓库
                  </a>
                ) : (
                  ""
                )}
              </div>
            );
          },
        },
      ],
      filterObj: {
        customerId: "",
        outBizId: "",
        wmsState: "",
        state: "",
        palletState: "",
      },
      currentRow: [],
      dialogVisible: false,
      editRow: {},
    };
  },
  methods: {
    createHeZhuOrder() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$confirm("确定要生成核注清单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            const request = this.buildHeZhuCreateReq();
            if (request.request.items.every((item) => item.qty === 0)) {
              this.$message.error("表体申报数量不能全为0");
              this.loading = false;
              return;
            }
            if (request.request.items.some((item) => !item.currency)) {
              this.$message.error("表体币制不能为空");
              this.loading = false;
              return;
            }
            this.loading = true;
            heZhuApi.createByStockoutOrder(request).then((res) => {
              if (res.value) {
                this.$message.success("生成核注清单成功");
                this.showMakeHeZhuDirectFormFlag = false;
                this.fetch();
              }
              this.loading = false;
            });
          });
        } else {
          return false;
        }
      });
    },
    buildHeZhuCreateReq() {
      return {
        request: {
          ...this.heZhuForm,
          items: this.stockoutGoods.map((item) => {
            return {
              toBStockoutOrderSkuId: item.id,
              stockId: item.stockId,
              unitPrice: item.unitPrice ? item.unitPrice.trim() : "",
              currency: item.currency ? item.currency : "",
              qty: item.planStockoutQuantity,
            };
          }),
        },
      };
    },
    copyCurrency() {
      if (this.stockoutGoods[0].currency) {
        this.stockoutGoods.forEach((item) => {
          this.$set(item, "currency", this.stockoutGoods[0].currency);
        });
      }
    },
    copyUnitPrice() {
      if (this.stockoutGoods[0].unitPrice) {
        this.stockoutGoods.forEach((item) => {
          this.$set(item, "unitPrice", this.stockoutGoods[0].unitPrice);
        });
      }
    },
    showMakeHeZhuDirectForm(row) {
      if (this.heZhuForm.toBStockoutOrderId !== row.id) {
        this.heZhuForm.toBStockoutOrderId = row.id;
        b2bApi.load({ toBStockoutOrderId: row.id }).then((res) => {
          this.stockoutGoods = res.items.map((it) => ({
            ...it,
            unitPrice: it.price,
          }));
        });
      }
      this.showMakeHeZhuDirectFormFlag = true;
    },
    jumpToHeZhuList(row) {
      this.$router.push({
        path: `/b2b/heZhu/${row.id}`,
      });
    },
    showDialog(row) {
      b2bApi.load({ toBStockoutOrderId: row.id }).then((res) => {
        const form = {
          toBStockoutOrderId: res.id,
          consignee: res.consignee,
          phone: res.phone,
          province: res.province,
          city: res.city,
          district: res.district,
          address: res.address,
        };
        this.toBStockoutOrderForm = form;
        this.dialogVisible = true;
      });
    },
    updateStockoutOrder() {
      b2bApi
        .update({ request: this.toBStockoutOrderForm })
        .then((res) => {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.fetch();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    sendWms(row) {
      b2bApi.sendWms({ toBStockoutOrderId: row.id }).then((res) => {
        if (res.value) {
          this.$message({
            message: "下发wms成功",
            type: "success",
          });
          this.fetch();
        } else {
          this.$message({
            message: "下发wms失败",
            type: "error",
          });
        }
      });
    },
    ship(row) {
      this.$confirm("确认出库?出库后会进行扣减库存", "仓库出库", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        b2bApi.load({ toBStockoutOrderId: row.id }).then((res) => {
          const params = {
            toBStockoutOrderId: res.id,
            items: res.items.map((item) => ({
              toBStockoutOrderSkuId: item.id,
              stockoutQuantity: item.planStockoutQuantity,
            })),
          };
          b2bApi.ship({ request: params }).then((res) => {
            this.$message.success("出库成功");
            this.fetch();
          });
        });
      });
    },
    cancel(row) {
      this.$confirm("确认取消?", "取消出库单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        b2bApi.cancel({ toBStockoutOrderId: row.id }).then((res) => {
          if (res.value) {
            this.$message.success("取消成功");
            this.fetch();
          }
        });
      });
    },
    jumpToCreate() {
      this.$router.push({
        name: "b2bCreate",
      });
    },
    submitForm(id) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.edit({
            request: { editInfo: this.editRow },
          })
            .then((res) => {
              if (res.value) {
                this.$message.success("编辑成功");
                this.resetForm();
              }
              this.loading = false;
              this.fetch();
            })
            .catch((err) => {
              // this.resetForm()
              this.fetch();
              this.loading = false;
            });
        }
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      b2bApi
        .pageQuery(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          this.itemMap = {};
          this.pagination.currentPage = res.page.pageIndex;
          this.pagination.pageSize = res.page.pageSize;
          this.pagination.totalCount = res.page.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList,
              },
            },
            {
              label: "外部订单号",
              model: "outBizId",
              type: type.INPUT,
            },
            {
              label: "仓库状态",
              model: "wmsState",
              type: type.SELECT,
              props: {
                data: [
                  { value: "INIT", label: "初始化" },
                  { value: "WMS_CREATE_SUCCESS", label: "已下发" },
                  { value: "WMS_CREATE_EXCEPTION", label: "下发异常" },
                ],
              },
            },
            {
              label: "出库单状态",
              model: "state",
              type: type.SELECT,
              props: {
                data: [
                  { value: "WAIT_STOCKOUT", label: "待出库" },
                  { value: "STOCKOUTING", label: "出库中" },
                  { value: "SHIPPED", label: "已出库" },
                  { value: "CANCELED", label: "已取消" },
                ],
              },
            },
          ],
        },
      ];
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      this.export({
        request: {
          queryInfo: { ...filterParams },
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>
